// Ejecuta el script cuando el DOM esté completamente cargado
document.addEventListener('DOMContentLoaded', function () {
  // Lista de cada SKU con su cantidad mínima requerida
  const minQtyBySku = [
    { sku: 'AFT00029', minQty: 100 },
    { sku: 'AFT00003', minQty: 100 },
    { sku: 'AFT00002', minQty: 100 },
    { sku: 'AFT00018', minQty: 100 },
    { sku: 'AFT00030', minQty: 100 },
    { sku: 'AFT00001', minQty: 100 },
    { sku: 'AFT00017', minQty: 100 },
    { sku: 'AFT00009', minQty: 100 },
    { sku: 'AFT00004', minQty: 100 },
    { sku: 'AFT00006', minQty: 100 },
    { sku: 'AFT00012', minQty: 100 },
    { sku: 'AFT00028', minQty: 100 },
    { sku: 'AFT00014', minQty: 100 },
    { sku: 'AFT00027', minQty: 100 },
    { sku: 'AFT00015', minQty: 100 },
    { sku: 'AFT00005', minQty: 100 },
    { sku: 'AFT00022', minQty: 100 },
    { sku: 'AFT00016', minQty: 100 },
    { sku: 'AFT00031', minQty: 100 },
    { sku: 'AFT00021', minQty: 100 },
    { sku: 'AFT00010', minQty: 100 },
    { sku: 'AFT00025', minQty: 100 },
    { sku: 'AFT00020', minQty: 100 },
    { sku: 'AFT00007', minQty: 100 },
    { sku: 'AFT00023', minQty: 100 },
    { sku: 'AFT00026', minQty: 100 },
    { sku: 'AFT00011', minQty: 100 },
    { sku: 'AFT00024', minQty: 100 },
    { sku: 'AFT00008', minQty: 100 },
    { sku: 'AFT00019', minQty: 100 },
    { sku: 'AFR00054', minQty: 50 },
    { sku: 'AFR00055', minQty: 50 }
  ];

  // Variables para los elementos del formulario
  const quantityInput = document.querySelector('input[name="quantity"]'); // Input de cantidad
  const variantInput = document.querySelector('input[name="id"]'); // Input oculto con el ID del variant
  const form = document.querySelector('form[action="/cart/add"]'); // Formulario de agregar al carrito
  const allVariants = window.ProductData?.variants || []; // Lista de variantes desde ProductData

  // Si falta algún elemento esencial, se cancela la ejecución
  if (!quantityInput || !variantInput || allVariants.length === 0) return;

  // Busca la variante seleccionada actualmente
  function getCurrentVariant() {
    return allVariants.find(v => v.id == variantInput.value);
  }

  // Aplica cantidad mínima si corresponde al SKU actual
  function applyMinQtyIfNeeded() {
    const variant = getCurrentVariant();
    if (!variant) return;

    const rule = minQtyBySku.find(item => item.sku === variant.sku); // Busca si existe regla para ese SKU
    const currentQty = parseInt(quantityInput.value); // Obtiene cantidad actual ingresada

    // Si hay regla y la cantidad es inválida o menor a la mínima, se corrige
    if (rule && (isNaN(currentQty) || currentQty < rule.minQty)) {
      quantityInput.value = rule.minQty;
    }
  }

  // Al cambiar la cantidad manualmente, valida la mínima
  quantityInput.addEventListener('change', applyMinQtyIfNeeded);

  // Al enviar el formulario (Agregar al carrito), valida también
  if (form) {
    form.addEventListener('submit', function (e) {
      const variant = getCurrentVariant();
      const rule = minQtyBySku.find(item => item.sku === variant?.sku);
      const currentQty = parseInt(quantityInput.value);

      // Previene envío si la cantidad no cumple y la ajusta
      if (rule && (isNaN(currentQty) || currentQty < rule.minQty)) {
        e.preventDefault();
        quantityInput.value = rule.minQty;
        alert(`Este producto tiene una compra mínima de ${rule.minQty} unidades.`);
      }
    });
  }

  // Detecta si cambia el variant (por ejemplo, desde un selector de tallas o color)
  variantInput.addEventListener('change', applyMinQtyIfNeeded);

  // Observa si el input de cantidad es modificado por scripts u otros cambios DOM
  const observer = new MutationObserver(applyMinQtyIfNeeded);
  observer.observe(quantityInput, { attributes: true, childList: false, subtree: false });

  // Ejecuta la validación al cargar la página
  applyMinQtyIfNeeded();
  
});